import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["shape", "label", "appearance", "isDisabled", "intent", "children", "className"];
import * as React from 'react';
import cn from 'classnames';
import { ControlAppearanceType, controlClasses, ControlShapeType, intentClass, safeInvoke } from '../../../../library';
export var InputButton = React.forwardRef(function (props, ref) {
  var shape = props.shape,
    label = props.label,
    appearance = props.appearance,
    isDisabled = props.isDisabled,
    intent = props.intent,
    children = props.children,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  function handleFocus(e) {
    e.stopPropagation();
    safeInvoke(props.onFocus, e);
  }
  return React.createElement("button", _extends({
    ref: ref,
    type: "button",
    className: cn('input-button', intentClass(intent), controlClasses({
      appearance: appearance,
      shape: shape
    }), className)
  }, rest, {
    onFocus: handleFocus
  }), label !== null && label !== void 0 ? label : props.children);
});
InputButton.displayName = 'InputButton';
InputButton.defaultProps = {
  appearance: ControlAppearanceType.FILL,
  shape: ControlShapeType.ROUNDED
};